import { useEffect, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

/* Default featured ticket CTA used on the home hero. The admin can rotate
   this from /admin-magic-portal → Featured Ticket tab as events come and go. */
const DEFAULT = {
 id: "nye",
 label: "NYE Tickets",
 price_label: "Adult $1,250",
 href: "/cruises/nye-cruises-sydney-harbour/book",
 options: [],
};

export default function useFeaturedTicket() {
 const [ticket, setTicket] = useState(DEFAULT);

 useEffect(() => {
  let cancelled = false;
  axios.get(`${API}/api/cms/featured-ticket`)
   .then(r => {
    const d = r?.data;
    if (!cancelled && d && d.id && d.label && d.href) {
     setTicket({
      id: d.id,
      label: d.label,
      price_label: d.price_label || "",
      href: d.href,
      options: Array.isArray(d.options) ? d.options : [],
     });
    }
   })
   .catch(() => { /* keep DEFAULT */ });
  return () => { cancelled = true; };
 }, []);

 return ticket;
}
